export default {"src":"/_next/static/media/Email.d6c3f832.svg","height":30,"width":37};